<div class="container-fluid p-0" id="forget-pwd">
    <div class="authentication-main">
        <div class="row">
            <div class="col-md-12">
                <div class="authentication-box">
                    <div class="text-center">
                    </div>
                    <div class="card mt-4">
                        <div class="card-body">
                            <div class="text-center">
                                <h4>Mot de passe oublié</h4>
                            </div>
                            <div class="theme-form">
                                <div class="form-group">
                                    <label class="col-form-label">Veuillez renseigner l’adresse email associée à votre compte. Nous vous enverrons les instructions pour créer un nouveau mot de passe.</label>
                                </div>  
                                <div class="form-group">
                                    <label for="email" class="col-form-label pt-0">Email</label>
                                    <input class="form-control" type="email" id="email" required="" [(ngModel)]="email" (keydown.enter)="reInit()">
                                </div>   
                                <div class="form-group form-row mt-3 mb-0 login-button-block">
                                    <button class="btn btn-block login-button" type="submit" (click)="reInit()">Réinitialiser</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid p-0" id="email-sent" style="display: none;">
    <div class="authentication-main">
        <div class="row">
            <div class="col-md-12">
                <div class="authentication-box">
                    <div class="text-center">
                    </div>
                    <div class="card mt-4">
                        <div class="card-body">
                            <div class="text-center">
                                <h4>Email envoyé</h4>
                            </div>
                            <div class="theme-form">
                                <div class="form-group">
                                    <label class="col-form-label">Un email de réinitialisation a bien été envoyé à l’email indiqué. Si cet email est bien associé à un compte, vous pourrez dorénavant réinitialiser votre mot de passe</label>
                                </div>  
                                <div class="form-group">
                                    <label class="col-form-label">Vous n’avez pas reçu cet email ? Vérifiez vos spams ou cliquez sur “Envoyer l’email à nouveau”</label>
                                </div>   
                                <div class="form-group form-row mt-3 mb-0 login-button-block">
                                    <button class="btn btn-block login-button" type="submit" (click)="reSendEmail()">Renvoyer l’email</button>
                                </div>
                                <div class="form-group form-row mt-3 mb-0 sign-up-button-block">
                                    <button class="btn btn-block sign-up-button" type="submit" (click)="login()">Se connecter</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
